import { _validate_null_ } from '@/util/validate'

const keyName = 'rc-25-'

/**
 * 存储 localStorage
 */
export const mall_set_store = (params = {}) => {
    let {
        name,
        content,
        type
    } = params

    name = keyName + name

    const obj = {
        dataType: typeof (content),
        content: content,
        type: type,
        datetime: new Date().getTime()
    }

    if (type) {
        sessionStorage.setItem(name, JSON.stringify(obj))
    } else {
        localStorage.setItem(name, JSON.stringify(obj))
    }
}

/**
 * 获取 localStorage
 */
export const mall_get_store = (params = {}) => {
    let {
        name,
        debug
    } = params

    name = keyName + name

    let obj = {}
    let content
    obj = sessionStorage.getItem(name)
    if (_validate_null_(obj)) {
        obj = localStorage.getItem(name)
    }

    if (_validate_null_(obj)) {
        return
    }

    try {
        obj = JSON.parse(obj)
    } catch (e) {
        return obj
    }

    if (debug) {
        return obj
    }

    if (obj.dataType === 'string') {
        content = obj.content
    } else if (obj.dataType === 'number') {
        content = Number(obj.content)
    } else if (obj.dataType === 'boolean') {
        content = eval(obj.content)
    } else if (obj.dataType === 'object') {
        content = obj.content
    }

    return content
}

/**
 * 删除localStorage
 */
export const removeStore = (params = {}) => {
    let {
        name,
        type
    } = params
    name = keyName + name
    if (type) {
        window.sessionStorage.removeItem(name)
    } else {
        window.localStorage.removeItem(name)
    }
}

/**
 * 获取全部localStorage
 */
export const getAllStore = (params = {}) => {
    const list = []
    const {
        type
    } = params
    if (type) {
        for (let i = 0; i <= window.sessionStorage.length; i++) {
            list.push({
                name: window.sessionStorage.key(i),
                content: mall_get_store({
                    name: window.sessionStorage.key(i),
                    type: 'session'
                })
            })
        }
    } else {
        for (let i = 0; i <= window.localStorage.length; i++) {
            list.push({
                name: window.localStorage.key(i),
                content: mall_get_store({
                    name: window.localStorage.key(i)
                })
            })
        }
    }
    return list
}

/**
 * 清空全部localStorage
 */
export const clearStore = (params = {}) => {
    const { type } = params
    if (type) {
        window.sessionStorage.clear()
    } else {
        window.localStorage.clear()
    }
}
